<template>
  <div class="filter-wrapper" >
    <div class="button-container" >
      <!-- Кнопка назад на десктопе -->
      <a href="/penthouses" v-if="!isMobile">
        <div class="button-back">
          <img src="/static/images/arrow_right.svg" alt="arrow" class="link-arrow__reverse">
          <span>Вернуться</span>
        </div>
      </a>
      <!-- Кнопка "Закрыть" на мобильном -->
      <div class="button-back" @click="openFilter" v-if="isMobile">
        <img src="/static/images/close.svg">
      </div>
    </div>
    <div class="title-wrapper">
      <div class="title">
        Подбор пентхаусов
      </div>
    </div>
    <!-- Old, nafeeg -->
    <!-- div class="content-wrapper" v-if="!isMobile">
      В каждом пентхаусе – просторная терраса с захватывающими дух видами.
      Величественная высотка МГУ или урбанистическая красота Москвы-Сити – будущие резиденты могут выбрать видовую доминанту на свой вкус.
      Неизменно одно – панорама города до самого горизонта и высокое, бескрайнее небо.
    </div -->
    <!-- New -->
    <div class="filters-container">
      <div class="filters-container__row">
        <div class="selection__tower" @click="towers = []">Все башни</div>
        <div class="selection__tower" :class="{'active' : towers.includes('SOLO')}" @click="toggleTower('SOLO')">Solo</div>
        <div class="selection__tower" :class="{'active' : towers.includes('FAMILY')}" @click="toggleTower('FAMILY')">Family</div>
        <div class="selection__tower" :class="{'active' : towers.includes('TANDEM')}" @click="toggleTower('TANDEM')">Tandem</div>
      </div>
      <!--  -->
      <div class="filters-container__row">
        <div class="filters-container__col-1">
          <div class="filters-container__col-title">Площадь <span class="filters-container__col-title-small">м<sup>2</sup></span></div>
          <div class="slider__area" ref="rangeSliderArea"></div>
          <div class="slider__result">
            <div class="slider__min">{{ Math.floor(areaMin) }}</div>
            <div class="slider__max">{{ Math.floor(areaMax) }}</div>
          </div>
        </div>
        <!--  -->
        <div class="filters-container__col-2">
          <div class="filters-container__col-title">Цена <span class="filters-container__col-title-small">р</span></div>
          <div class="slider__price" ref="rangeSliderPrice"></div>
          <div class="slider__result">
            <div class="slider__min">{{ Math.floor(priceMin) }} млн</div>
            <div class="slider__max fix__maxwidth">{{ Math.floor(priceMax) }} млн</div>
          </div>
        </div>
        <!--  -->
      </div>
      <div class="filters-container__row space-betweened">
        <div class="filters-container__col">
          <div class="filters-container__col-title">Вид</div>
        </div>
        <div class="filters-container__col">
          <label class="filters-container__label" for="MoscowCity"><input type="checkbox" v-model="viewCity" id="MoscowCity"><span class="checkmark"></span> Москва Сити</label>
          <label class="filters-container__label" for="msu"><input type="checkbox" v-model="viewMsu" id="msu"><span class="checkmark"></span> Высотка МГУ</label>
        </div>
        <div class="filters-container__col">
          <label class="filters-container__label" for="riverRamenka"><input type="checkbox" v-model="viewRiver" id="riverRamenka"><span class="checkmark"></span> Долина реки Раменки</label>
          <label class="filters-container__label" for="park50let"><input type="checkbox" v-model="viewPark" id="park50let"><span class="checkmark"></span> Парк 50 лет Октября</label>
        </div>
      </div>

      <div class="filters-container__row aligned-center">
        <div>
          <div class="button-bordered"  @click="openFilter()">
            Подобрать
            <img src="/static/images/arrow_right.svg" alt="arrow" class="arrow__right">
          </div>
        </div>
        <div class="button-reset" @click="resetFilter(); openFilter();">
          Сбросить фильтр
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import noUiSlider from 'nouislider'
  import { mapState, mapMutations } from 'vuex'
  export default {
    name: "FilterBlock",
    data: () => ({
      priceMin: 0,
      priceMax: null,
      areaMin: 0,
      areaMax: 0,
      viewCity: false,
      viewRiver: false,
      viewMsu: false,
      viewPark: false,
      towers: []
    }),
    computed: {
      ...mapState(['windowWidth', 'filterIsOpened']),
      views() {
        return [this.viewCity ? 'moscowCity' : false,
                this.viewRiver ? 'river' : false,
                this.viewMsu ? 'msu' : false, 
                this.viewPark ? 'park' : false].filter(item => item)
      },
      isMobile() {
        return this.windowWidth < 1200
      },
      filterParams() {
        return {views: this.views,
          towers: this.towers,
          areaMin: this.areaMin,
          areaMax: this.areaMax,
          priceMin: this.priceMin,
          priceMax: this.priceMax
        }
      }
    },
    methods: {
      ...mapMutations(['filterPenthouse', 'openFilter']),
      resetFilter() {
        this.viewCity = false;
        this.viewRiver = false;
        this.viewMsu = false;
        this.viewPark = false;
        this.towers = [];
        this.areaMin = 150;
        this.areaMax = 250;
        this.priceMin = 66;
        this.priceMax = 123;
      },
      toggleTower(name) {
        if (this.towers.includes(name)) {
          this.towers.splice(this.towers.indexOf(name), 1)
        } else {
          this.towers.push(name)
        }
      },
      initRangeSlider() {
        noUiSlider.create(this.$refs.rangeSliderPrice, {
          start: [this.$route.query.priceMin ? this.$route.query.priceMin : 66, this.$route.query.priceMax ? this.$route.query.priceMax : 123],
          connect: true,
          step: 1,
          range: {
            'min': [66],
            'max': [123]
          }
        });
        noUiSlider.create(this.$refs.rangeSliderArea, {
          start: [this.$route.query.areaMin ? this.$route.query.areaMin : 140, this.$route.query.areaMax ? this.$route.query.areaMax : 250],
          connect: true,
          step: 1,
          range: {
            'min': [150],
            'max': [250]
          }
        });
        this.$refs.rangeSliderPrice.noUiSlider.on('update', values => {
          this.priceMin = values[0];
          this.priceMax = values[1]
        });
        this.$refs.rangeSliderArea.noUiSlider.on('update', values => {
          this.areaMin = values[0];
          this.areaMax = values[1]
        })
      }
    },
    watch: {
      filterParams() {
        let query = this.filterParams

        this.$router.push({query})
      }
    },
    mounted() {
      this.initRangeSlider();
    }
  }
</script>

<style lang="stylus" scoped>
  @import '../styles/tools'
  .filter-wrapper
    display flex
    flex-direction column

  .title-wrapper
    font-family "Asket Extended"
    font-weight 400
    line-height 1.2
    letter-spacing 2px
    width-between-property 'font-size' 320 12 1200 46 true true
    text-transform uppercase
    color $white
    margin-bottom 20px
    @media (min-width 1200px)
      margin-top 0
      width-between-property 'margin-bottom' 1200 40 1920 60 true true

  .content-wrapper // Архивный стиль
    font-size 16px
    font-family Roboto,Arial,Helvetica,sans-serif
    color $white
    line-height 1.35

  .filters-container
    max-width 500px
    &__label
      position relative
      padding-left 15px
      display flex
      justify-content flex-start
      align-items center
      color $white
      font-family "Asket Extended"
      font-weight 300
      width-between-property 'font-size' 320 9 1920 12 true true
      cursor pointer
      margin-bottom 15px
    &__row
      display flex
      flex-direction row
      justify-content flex-start
      margin-bottom 30px
      &.space-betweened
        justify-content space-between
      &.aligned-center
        justify-content center
        align-items center
    &__col
      width auto
      display flex
      flex-direction column
      &-2
        width 50%
        padding-left 18pxva
      &-1
        width 50%
        padding-right 18px
      &-title
        font-family "Asket Extended"
        width-between-property 'font-size' 320 10 1920 14 true true
        font-weight 500
        line-height 1.6
        color $backgroundDarkGrey
        text-transform uppercase
        user-select none
        width-between-property 'margin-bottom' 320 15 1920 20 true true
        &-small
          font-weight 500
          opacity .4
          font-size 8px
          user-select none

  .selection__tower
    font-family "Asket Extended"
    width-between-property 'font-size' 320 10 1920 14 true true
    font-weight 500
    line-height 1.6
    color $backgroundDarkGrey
    cursor pointer
    text-transform uppercase
    margin-right 15px
    &::after
      content ''
      position absolute
      bottom 0
      left 0
      width 100%
      height 1px
      background #fff
      opacity 0
      transition opacity .2s ease-in-out

    &.active
      position relative
      &::after
        opacity 1
      

.button-bordered
  width-between-property 'padding-top' 320 10 1920 15 true true
  width-between-property 'padding-bottom' 320 10 1920 15 true true
  width-between-property 'padding-left' 320 12 1920 20 true true
  width-between-property 'padding-right' 320 12 1920 20 true true
  font-family "Asket Extended"
  font-weight 500
  width-between-property 'font-size' 320 8 1920 12 true true
  border 2px solid rgba(214, 224, 231, .4);
  border-radius 20px
  margin-right 20px
  color $white
  text-transform uppercase

.button-reset
  font-family "Asket Extended"
  font-weight 500
  width-between-property 'font-size' 320 8 1920 12 true true
  color $white
  cursor pointer


.arrow__right
  margin-bottom -1px
  margin-left 5px
  object-fit contain
  width 20px

.slider
  width 100%
  &__price, &__area
    margin-bottom 20px
  &__result
    margin-bottom 40px
    display flex
    justify-content space-between
    font-family "Asket Extended"
    font-weight 300
    width-between-property 'font-size' 320 8 1920 12 true true
    color $white
    user-select none

[type="checkbox"]
  position absolute
  opacity 0
  cursor pointer
  height 0
  width 0

.checkmark
  position absolute
  top -3px
  left 0
  height 12px
  width 12px
  background-color transparent
  border 1px solid rgba(255, 255, 255, .6)

.filters-container__label:hover .checkmark, .filters-container__label input:checked ~ .checkmark
  background-color white

.checkmark:after
  content "";
  position absolute
  display none

.filters-container__label input:checked ~ .checkmark:after
  display block
  border solid $backgroundBlue
  height 9px
  width 5px
  left 2px
  border-width 0 3px 3px 0
  transform rotate(45deg)

.fix__maxwidth
  @media (max-width 400px)
    max-width 10px


.button-container
  display flex
  width 100%
  margin 10px 0 40px 0
  @media (max-width 1000px)
    margin 35px 0 30px 0

.bordered-link
  font-family "Asket Extended"
  width-between-property 'font-size' 320 8 1000 14 true true
  text-transform uppercase
  padding 15px 30px 12px
  border 1px solid $white
  border-radius 100px
  color $white
  display flex
  justify-content center
  align-items center
  @media (min-width 1000px)
    font-size 14px

.link-arrow
  padding-left 15px
  margin-top -3px

  &__reverse
    width 55px
    height 7px
    transform rotatey(180deg)
    object-fit cover
    margin-right 15px
    margin-top 2px



.button-back
  font-family Roboto,Arial,Helvetica,sans-serif
  font-weight 500
  font-size 12px
  text-transform uppercase
  opacity .8
  color $white
  display flex
  width 100%

</style>